
function Visit(){

    if( $('#panoDIV').length > 0 ){
        this.build();
    }

}


Visit.prototype.build = function(){

    embedpano({
        swf: mcubeArgs.themeLink + "/coop360data/coop360.swf",
        target: "panoDIV",
        passQueryParameters:true
    });

};